export default __webpack_public_path__ + "static/media/17.76194e66.jpg";